/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import ListItemButton from '@mui/material/ListItemButton';
import { withStyles } from '@mui/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isRoleExists } from '../common/common';
import { actionCreators } from '../store/ViewBulletin';
import BulletinNumberSearch from './BulletinNumberSearch';
import MenuList from './MenuList';
import ProductClassification from './ProductClassification';
import SerialNumberSearch from './SerialNumberSearch';
import UploadBulletin from './UploadBulletinView';

const styles = () => ({
    selectInput: {
        backgroundColor: '#fff',
        borderRadius: 0,
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)',
        '& em': {
            fontSize: 14,
            fontStyle: 'normal'
        }
    },
    dropdown: {
        fontSize: 14,
        fontStyle: 'normal',
        marginLeft: 10
    },
    bulletinleftPanelistItem: {

        overflow: 'hidden',
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        width: '90%',
        fontSize: 10,
        display: 'block'
    },
    limitedTag: {
        backgroundColor: '#ffbe00',
        color: '#000',
        padding: '2px 6px',
        borderRadius: '4px',
        marginLeft: '10px',
        fontSize: '10px',
        fontWeight: 'bold',
        display: 'inline-block',
    }
});
interface Props {
    isMenuExpanded: boolean,
    classes?: any,
    selectedFamily: any,
    selectedProductName: any,
    selectedProductModel: any,
    families: any
    productModels: any,
    productNames: any,
    isBulletinLoading: any,
    serialNumber: any,
    UpdateProductFamilies: Function,
    FilterNames: Function,
    FilterModels: Function,
    UpdateProductClassificationonSerialNumber: Function,
    UpdateSerialNumber: Function,
    UpdateSelectedFamily: Function,
    UpdateSelectedProductName: Function
    UpdateSelectedProductModel: Function
    allserviceBulletinData: any,
    filteredserviceBulletinData: any,
    selectedBulletin: any,
    isBulletinDetailLoading: any,
    selectBulletin: Function,
    unSelectBulletin: Function,
    Loadingbulletindetails: Function,
    Completedloadingbulletindetails: Function,
    isAuthenticatedOnce: boolean,
    LoadServiceBulletin: Function,
    StopLoading: Function,
    ClearViewBulletinData: Function,
    ClearBulletinList: Function,
    UpdateBulletins: Function,
    LoadServiceBulletinforNumber: Function,
    UpdateBulletinNumber: Function,
    filterBulletin: Function,
    bulletinNumber: any
}
interface State {
    currentUrl: any,
    selectedfilterValue: any
}

const ProductFamily = 'selectedFamily';
const ProductName = 'selectedProductName';
const ProductModel = 'selectedProductModel';
class ServiceBulletin extends React.Component<Props, State> {
    state = { isAuthenticatedOnce: false, currentUrl: '', selectedfilterValue: 'ALL' };
    filter = [{ id: 1, name: 'ALL' }, { id: 2, name: 'ACTIVE' }, { id: 3, name: 'INACTIVE' }];

    handleSerialNumberSearch = async (twoDproductFamilyid: any, twoDproductNameid: any, twodModelid: any, serviceBulletins: any) => {
        await this.props.FilterNames(this.props.families, twoDproductFamilyid);
        await this.props.FilterModels(this.props.productNames, twoDproductNameid);
        await this.props.UpdateProductClassificationonSerialNumber(twoDproductFamilyid,
            twoDproductNameid,
            twodModelid,
            serviceBulletins);
        this.setState({ selectedfilterValue: 'ALL' });
    };

    handlefilter = (item: any) => {
        if (item != null) {
            const value = this.filter.find((x: any) => {
                return x.id === item;
            });
            if (value !== undefined) {
                this.setState({ selectedfilterValue: value.name });

                console.log(this.state.selectedfilterValue);

                if (this.props.allserviceBulletinData != null && this.props.allserviceBulletinData !== undefined) {
                    const copyArray = JSON.parse(JSON.stringify(this.props.allserviceBulletinData));
                    if (value.id === 1) {
                        var newArray = this.props.allserviceBulletinData;
                    }
                    if (value.id === 2) {
                        var newArray = copyArray.filter(function (el: any) {
                            return el.serviceBulletinStatusId === 0 || el.serviceBulletinStatusId === 4;
                        });
                    }
                    if (value.id === 3) {
                        var newArray = copyArray.filter(function (el: any) {
                            return el.serviceBulletinStatusId === 1;

                        });
                    }
                    this.props.filterBulletin(value.id, newArray);
                    this.props.unSelectBulletin();
                }
            }
        }
    };

    LoadServiceBulletin = (data: any) => {
        this.props.LoadServiceBulletin(data);
    };

    LoadServiceBulletinNumber = (data: any) => {
        this.props.LoadServiceBulletinforNumber(data);
    };

    UpdateSerialNumber = (data: any) => {
        this.props.UpdateSerialNumber(data);
    };

    UpdateBulletinNumber = (data: any) => {
        this.props.UpdateBulletinNumber(data);
    };

    StopLoading = () => {
        this.props.StopLoading();
    };

    ClearAll = () => {
        this.props.ClearBulletinList();
    };

    handleClassificationChange = (event: any) => {
        if (event.target.value !== '') {
            switch (event.target.name) {
                case ProductFamily:
                    this.props.UpdateSelectedFamily([event.target.value]);
                    this.props.FilterNames(this.props.families, [event.target.value]);
                    break;
                case ProductName:
                    this.props.UpdateSelectedProductName([event.target.value]);
                    this.props.FilterModels(this.props.productNames, [event.target.value]);
                    break;
                case ProductModel:
                    this.props.UpdateSelectedProductModel([event.target.value]);
                    break;
            }
        }
        this.setState({ selectedfilterValue: 'ALL' });
    };

    handleBulletinNumberSearch = async (serviceBulletins: any) => {
        await this.props.UpdateBulletins(serviceBulletins);
        this.setState({ selectedfilterValue: 'ALL' });
    };

    async componentDidMount() {
        this.props.ClearViewBulletinData();
    }

    renderLeft = (data: any, classes: any, id: any) => {
        return (
            <Paper className="manualPaper" elevation={0} key={data[id]}
                style={{ backgroundColor: data.serviceBulletinStatusId === 0 || data.serviceBulletinStatusId === 4 ? '' : 'rgba(0, 0, 0, 0.08)' }}>
                <ListItemButton key={data[id]} onClick={this.selectBulletinItemClick(data, id)}
                    selected={this.props.selectedBulletin && data[id] === this.props.selectedBulletin[id]}
                    className={(this.props.selectedBulletin && data[id] === this.props.selectedBulletin[id]) ? 'selectedBulletin' : 'bulletinListView'}>
                    <ListItemText >
                        <div >
                            <Grid container direction="column" className="font14" style={{ width: '100%' }}>
                                <Grid container justifyContent="space-between" alignItems="center" style={{ display: 'flex', flexWrap: 'nowrap' }}>
                                    <div className="headerLeft trimText" style={{ flex: '2 1 auto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {data.bulletinNumber}
                                    </div>
                                    {data.isLimited && <Grid className={classes.limitedTag} style={{ flex: '0 0 auto', marginRight: '10px' }}>Limited</Grid>}
                                    <div className="font10 modelName" style={{ flex: '0 0 auto', whiteSpace: 'nowrap' }}>
                                        {new Date(data.startDate + 'Z').toLocaleDateString()}
                                    </div>
                                </Grid>
                                <Grid style={{ width: '100%' }}>
                                    <span className={classes.bulletinleftPanelistItem}>
                                        {data.description}
                                    </span>
                                </Grid>
                            </Grid>
                        </div>
                    </ListItemText>
                </ListItemButton>
            </Paper>
        );
    };

    UpdateProductFamilies = (data: any) => {
        this.props.UpdateProductFamilies(data);
    };

    selectBulletinItemClick = (data: any, id: any) => async (event: any) => {
        this.setState(() => {
            this.props.selectBulletin(data);
        });
    };

    render() {
        const { classes, filteredserviceBulletinData, selectedFamily, selectedProductName, selectedProductModel,
            isBulletinLoading, isBulletinDetailLoading, bulletinNumber, serialNumber } = this.props;
        const isMenuExpanded = this.props.isMenuExpanded;
        return (
            <Grid className="viewBulletinGrid">

                <Grid container justifyContent="space-between">
                    <SerialNumberSearch isBulletin={true} isDownloads={false} isLaborTimeGuide={false} isInstrumentConstants={false}
                        handleSerialNumberSearch={this.handleSerialNumberSearch}
                        LoadServiceManual={this.LoadServiceBulletin}
                        UpdateSerialNumber={this.UpdateSerialNumber} StopLoading={this.StopLoading}
                        selectedFamily={this.props.selectedFamily} selectedProductName={this.props.selectedProductName} selectedProductModel={this.props.selectedProductModel}
                        productModels={this.props.productModels} families={this.props.families} productNames={this.props.productNames} isLoading={this.props.isBulletinLoading}
                        serialNumber={this.props.serialNumber} ClearAll={this.ClearAll} />
                    or
                    <ProductClassification families={this.props.families} selectedFamily={this.props.selectedFamily} selectedProductName={this.props.selectedProductName}
                        selectedProductModel={this.props.selectedProductModel}
                        productModels={this.props.productModels} productNames={this.props.productNames} handleManualClassificationChange={this.handleClassificationChange}
                        isLoading={this.props.isBulletinLoading} UpdateProductFamilies={this.UpdateProductFamilies}
                    /><div>
                        {isRoleExists(4) && <UploadBulletin {...({ title: 'Upload' } as any)} />}</div>

                </Grid>
                <div className="divheight" />
                <div>
                    <BulletinNumberSearch handleBulletinNumberSearch={this.handleBulletinNumberSearch} LoadServiceBulletin={this.LoadServiceBulletinNumber}
                        UpdateBulletinNumber={this.UpdateBulletinNumber} StopLoading={this.StopLoading}
                        isLoading={this.props.isBulletinLoading} bulletinNumber={this.props.bulletinNumber} ClearAll={this.ClearAll} />
                </div>
                <div className="divheight" />
                <div>
                    <MenuList listItems={this.filter} onClick={this.handlefilter} selectTitle={'Type'} displaySelectedItemInTitle={true}
                        selectedItem={this.state.selectedfilterValue} />
                </div>
                <Grid container justifyContent="space-between" className="viewManualListPDF">
                    <Grid className={isMenuExpanded ? 'viewManualLeftExpanded' : 'viewManualLeft'}>

                        {
                            (selectedFamily || selectedProductName || selectedProductModel || serialNumber || bulletinNumber) ?

                                (isBulletinLoading ?
                                    <div className="leftInitial">
                                        <CircularProgress color="secondary" />
                                    </div> :
                                    (filteredserviceBulletinData && filteredserviceBulletinData.length ?
                                        <div>
                                            <div className="resultsHeader font14 boldFont">Results</div>
                                            <List component="nav" className={classes.rootList}>
                                                {filteredserviceBulletinData.map((x: any) => {
                                                    return this.renderLeft(x, classes, 'serviceBulletinId');
                                                })
                                                }
                                            </List>
                                        </div>
                                        :
                                        <div className="leftInitial">No Data for the selected filter</div>)
                                )
                                :
                                <div className="leftInitial">Apply filter to populate this list</div>
                        }

                    </Grid>
                    <div className="divider"></div>
                    <Grid className={isMenuExpanded ? 'rightExpanded' : 'right'}>
                        {isBulletinDetailLoading ?
                            <div className="rightInitial">
                                <CircularProgress color="secondary" />
                            </div>
                            :
                            <div>
                                {this.props.selectedBulletin !== undefined ?
                                    <div>
                                        <Grid>
                                            <Grid container justifyContent="space-between" className="serviceManualDetailWidth">
                                                <div className="bulletinRightContentHeader"> {(this.props.selectedBulletin.bulletinNumber == null ||
                                                    this.props.selectedBulletin.bulletinNumber === undefined) ? '' : this.props.selectedBulletin.bulletinNumber}</div>
                                                <div className="inActiveBulletin">
                                                    {this.props.selectedBulletin.serviceBulletinStatusId === 0 || this.props.selectedBulletin.serviceBulletinStatusId === 4 ?
                                                        '' : 'INACTIVE (Content moved to Service Manual or not valid any longer)'}</div>
                                                <div className="serviceBulletinRightContents font14">{new Date(this.props.selectedBulletin.startDate + 'Z')
                                                    .toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })}</div>
                                            </Grid>
                                        </Grid>
                                        <div className="serviceBulletinDescriptionContents font13"><br/>
                                            {(this.props.selectedBulletin.description === null ||
                                            this.props.selectedBulletin.description === undefined) ? '' : this.props.selectedBulletin.description}</div>

                                        <Grid className="pdfContainer pdfContainerWithData">
                                            {this.props.selectedBulletin !== undefined &&
                                                this.props.isAuthenticatedOnce &&
                                                <object data={this.props.selectedBulletin.serviceBulletinURL} type="application/pdf" className="viewManualPDf" >
                                                    <embed src={this.props.selectedBulletin.serviceBulletinURL} type="application/pdf" />
                                                </object>}
                                        </Grid>
                                    </div>
                                    :
                                    <div className="pdfContainer">
                                        <p>Select a document from the list</p>
                                    </div>
                                }
                            </div>
                        }
                    </Grid>
                </Grid>
            </Grid>);
    }
}
const mapStateToProps = (state: any) => ({
    state: state.viewBulletin,
    data: state.viewBulletin.data,
    families: state.viewBulletin.families,
    allserviceBulletinData: state.viewBulletin.allserviceBulletinData,
    filteredserviceBulletinData: state.viewBulletin.filteredserviceBulletinData,
    selectedFamily: state.viewBulletin.selectedFamily,
    selectedProductName: state.viewBulletin.selectedProductName,
    selectedProductModel: state.viewBulletin.selectedProductModel,
    isBulletinLoading: state.viewBulletin.isBulletinLoading,
    isMenuExpanded: state.navMenu.isMenuExpanded,
    serialNumber: state.viewBulletin.serialNumber,
    bulletinNumber: state.viewBulletin.bulletinNumber,
    productModels: state.viewBulletin.productModels,
    productNames: state.viewBulletin.productNames,
    isBulletinDetailLoading: state.viewBulletin.isBulletinDetailLoading,
    selectedBulletin: state.viewBulletin.selectedBulletin,
    isAuthenticatedOnce: state.viewBulletin.isAuthenticatedOnce
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

const StyledServiceBulletin: any = withStyles(styles as any)(ServiceBulletin);
export default connect(
    mapStateToProps,
    mapDispatchtoProps
)(StyledServiceBulletin as any);
